import { render, staticRenderFns } from "./StrategyNotes.vue?vue&type=template&id=1fd8bf24&scoped=true"
import script from "./StrategyNotes.vue?vue&type=script&lang=js"
export * from "./StrategyNotes.vue?vue&type=script&lang=js"
import style0 from "./StrategyNotes.vue?vue&type=style&index=0&id=1fd8bf24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8bf24",
  null
  
)

export default component.exports